import styled from "styled-components";
import theme from "../../themes/simple-theme";

interface IProps {
  enlarged?: boolean;
  fullheight?: boolean;
  transparent?: boolean;
  white?: boolean;
  text?: boolean;
}

const Widget = styled.div`
  position: relative;
  ${({ enlarged }: IProps) =>
    enlarged
      ? `
    padding: 3.5rem 2rem;
    `
      : `padding: 2rem;`};

  ${({ transparent }: IProps) =>
    `border-radius: ${theme.global.radius};
    background-color: ${transparent ? `transparent` : theme.color.secondary};
    `};
  ${({ text }: IProps) => (text ? `padding: 6rem;` : ``)};
  ${({ transparent }: IProps) => (transparent ? `padding: 8.5rem 5rem;` : ``)};
  ${({ white }: IProps) =>
    white ? `background-color: ${theme.color.white};` : ``};
  ${({ fullheight }: IProps) => (fullheight ? `height: 100%;` : ``)};
`;

export default Widget;



// WEBPACK FOOTER //
// ./src/components/common/Widget.tsx